module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f63f.509c4f6b.svg";